import { render, staticRenderFns } from "./logisimportbox.vue?vue&type=template&id=13e11d3f&scoped=true"
import script from "./logisimportbox.vue?vue&type=script&lang=js"
export * from "./logisimportbox.vue?vue&type=script&lang=js"
import style0 from "./logisimportbox.vue?vue&type=style&index=0&id=13e11d3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e11d3f",
  null
  
)

export default component.exports